/**
 * Entry·서비스 카드 라벨 색상
 * @description 알려진 라벨은 고정 색, 그 외 커스텀 라벨(Zero Trust, 차세대 ITSM 등)은 문자열 해시로 구분
 */

const PREDEFINED_LABEL_COLORS: Record<string, string> = {
  Module: 'bg-blue-100 text-blue-700',
  Portal: 'bg-purple-100 text-purple-700',
  Customize: 'bg-orange-100 text-orange-700',
  System: 'bg-gray-100 text-gray-700',
  Service: 'bg-sky-100 text-sky-700',
  TBD: 'bg-red-100 text-red-700',
};

const DYNAMIC_LABEL_PALETTE = [
  'bg-emerald-100 text-emerald-700',
  'bg-amber-100 text-amber-800',
  'bg-rose-100 text-rose-700',
  'bg-indigo-100 text-indigo-700',
  'bg-teal-100 text-teal-700',
  'bg-fuchsia-100 text-fuchsia-700',
  'bg-cyan-100 text-cyan-700',
  'bg-lime-100 text-lime-800',
  'bg-violet-100 text-violet-700',
  'bg-pink-100 text-pink-700',
  'bg-yellow-100 text-yellow-800',
  'bg-slate-100 text-slate-700',
] as const;

function hashString(value: string): number {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = (hash * 31 + value.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

/** 라벨 텍스트에 대응하는 Tailwind 배지 클래스 반환 */
export function getServiceLabelColorClass(label: string): string {
  const key = label.trim();
  if (!key) return PREDEFINED_LABEL_COLORS.TBD;

  const predefined = PREDEFINED_LABEL_COLORS[key];
  if (predefined) return predefined;

  return DYNAMIC_LABEL_PALETTE[hashString(key) % DYNAMIC_LABEL_PALETTE.length];
}
